// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:48:46.907Z
// Property: River's Cove (ID: 6767906449167252)
// Collections: 22 amenities, 8 floorplans (live), 16 photos, 80 POIs, 4 reviews, 5 office hours, 10 fees (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167252",
  "property_external_id": "877788",
  "property_zillow_url": "https://www.zillow.com/apartments/germantown-wi/river's-cove/5ZMpjz/",
  "property_apartments_url": "https://www.apartments.com/rivers-cove-germantown-wi/6cfht8t/",
  "property_google_business_url": "https://www.google.com/maps/place/River's+Cove/data=!4m2!3m1!1s0x0:0xcdfc61f969f46e27?sa=X&ved=2ahUKEwjh9Lu0pYSTAxVBjpUCHbQBFtkQ_BJ6BAhFEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47737656697",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "river's-cove",
  "property_name": "River's Cove",
  "property_website_url": "https://www.riverscoveapartments.com",
  "property_domain": "https://www.riverscoveapartments.com",
  "property_address": "W172N11392 Division Rd",
  "property_full_address": "W172N11392 Division Rd, Germantown, WI 53022",
  "property_address_1": "W172N11392 Division Rd",
  "property_address_2": null,
  "property_address_city": "Germantown",
  "property_address_state": "WI",
  "property_address_zip_full": "53022",
  "property_address_zip": "53022",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Washington County",
  "property_address_latitude": "43.2244161",
  "property_address_longitude": "-88.1222086",
  "property_email": "Riverscove@weidner.com",
  "property_phone": "2625884703",
  "property_call_tracking_phone": "262-293-4725",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At River's Cove in Germantown, enjoy spacious two and three-bedroom apartments featuring serene views, modern amenities, and a vibrant community. With controlled access, planned activities, and a picturesque pond, we blend comfort and convenience. Embrace the lifestyle with your pet, prime amenities, and welcoming walking trails. Secure your oasis today!",
  "property_long_description": "**Discover Your Perfect Home at River's Cove in Germantown, WI!**\n\nWelcome to River's Cove, where comfort meets convenience in our spacious two and three-bedroom apartment homes. Nestled alongside the breathtaking views of Menomonee River and Black Stone Creek Golf Course, our community offers an unparalleled living experience that combines serenity and modern living.\n\nStep inside and be captivated by our thoughtfully designed interiors featuring cathedral ceilings, private patios or balconies, and energy-efficient appliances, with select units showcasing luxurious stainless steel finishes. Enjoy the warmth of a wood-burning fireplace and the convenience of in-unit washers and dryers, ensuring your everyday life is as comfortable as it is stylish.\n\nRiver's Cove isn't just about beautiful apartments; we prioritize community living with a variety of amenities to enhance your lifestyle. Enjoy our controlled access, on-site maintenance, and professional management team committed to your satisfaction. Engage in planned social activities, relax in the lounge or courtyard, and take advantage of our picnic area complete with grills for those summer cookouts.\n\nOur pet-friendly community welcomes furry friends, while ample walking and biking trails make outdoor adventures effortless. Families will appreciate the proximity to Rockfield Elementary and Kennedy Middle School, as well as our exclusive discount at the Lake Park Recreation Center.\n\nWhether you're looking for a short-term lease or a long-term home, find your new sanctuary at River's Cove. Browse our availability today or schedule a tour to experience everything our vibrant community has to offer! Make River's Cove your next home sweet home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-570b-7693-ae51-c86e2bd958a2.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a fireplace, sofa, coffee table, and large window overlooking a lake.",
    "public_id": "019d0229-570b-7693-ae51-c86e2bd958a2",
    "storage_key": "property/6767906449167252/019d0229-570b-7693-ae51-c86e2bd958a2.webp",
    "width": 1024,
    "height": 684
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "112",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": "34",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.85714285714286",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Deposit: $650",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://riverscoveapartments.securecafe.com/onlineleasing/river-s-cove/floorplans.aspx",
  "property_resident_portal_url": "https://riverscoveapartments.securecafenet.com/residentservices/river-s-cove/userlogin",
  "property_apply_now_url": "https://riverscoveapartments.securecafe.com/onlineleasing/river-s-cove/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/01a13bcc-3a77-7256-8b6e-29ec535cb3ab.webp",
  "property_primary_logo_media": {
    "alt_text": "River's Cove Apartment Homes logo",
    "public_id": "01a13bcc-3a77-7256-8b6e-29ec535cb3ab",
    "storage_key": "property/6767906449167252/01a13bcc-3a77-7256-8b6e-29ec535cb3ab.webp",
    "width": 224,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/01a13bcc-7c03-74d8-8166-71570bf5cee8.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a13bcc-7c03-74d8-8166-71570bf5cee8",
    "storage_key": "property/6767906449167252/01a13bcc-7c03-74d8-8166-71570bf5cee8.webp",
    "width": 224,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/01a13bcc-70c0-754c-8307-8bac57b702b5.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a13bcc-70c0-754c-8307-8bac57b702b5",
    "storage_key": "property/6767906449167252/01a13bcc-70c0-754c-8307-8bac57b702b5.webp",
    "width": 224,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#686963",
  "property_secondary_color": "#8e7a53",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "907 - 1200",
  "property_sqft_min": "907",
  "property_sqft_max": "1200",
  "property_price_range": "1625 - 3555",
  "property_price_min": "1605",
  "property_price_max": "3545",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/riverscoveapartments/",
  "property_instagram_url": "https://www.instagram.com/riverscoveapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJjQmZUdr-BIgRJ270aflh_M0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to River's Cove",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to River's Cove in Germantown, WI, where modern living meets nature’s beauty. Choose from spacious two or three-bedroom apartments featuring gourmet kitchens, soaring cathedral ceilings, and serene views of the Menomonee River. Enjoy resort-style amenities like a tranquil pond, picnic areas, and social events—life here is a seamless blend of comfort and community!",
  "property_home_floorplans_blurb": "Welcome to River's Cove in Germantown, WI, where comfort meets style in every thoughtfully designed floor plan. Enjoy spacious living, modern amenities, and a vibrant community atmosphere. Uncover your ideal living space today—browse our available apartment homes and elevate your lifestyle in a community that's as unique as you are!",
  "property_home_gallery_blurb": "At River's Cove in Germantown, WI, your dream lifestyle awaits! Choose from spacious two- and three-bedroom homes adorned with stunning views of the Menomonee River. With amenities like a serene pond, grilling areas, and in-home washers/dryers, every corner radiates comfort. Picture yourself living here—embrace the vibrant community today!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Germantown, River's Cove offers spacious two and three-bedroom apartments surrounded by vibrant local attractions. Enjoy leisurely afternoons at nearby Kettle Hills Golf Course, explore the Mequon Nature Preserve, or unwind at Dretzka Park. Embrace a lifestyle rich in convenience and community at River's Cove.",
  "property_home_reviews_blurb": "Nestled in the heart of Germantown, River's Cove enchants residents with its tranquil surroundings and vibrant community spirit. As one resident raves, “Living here feels like being on a perpetual vacation.” Dive into our reviews and see why your new home awaits at River's Cove!",
  "property_neighborhood_blurb": "At River's Cove in Germantown, WI, vibrant community living awaits you. Enjoy nearby outdoor adventures at Mequon Nature Preserve and Kettle Hills Golf Course, or stay active at Wisconsin Athletic Club and Planet Fitness. Unwind at Village Park or discover unique finds at the Redner's Rescued Cat Figurine Mewseum. Your ideal lifestyle starts here!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At River's Cove in Germantown, WI, our spacious two and three-bedroom apartments redefine comfort. Bask in serene water and golf course views while enjoying controlled access, planned social activities, and a welcoming atmosphere. With delightful amenities including walking trails, a picnic area, and a community lounge, your perfect lifestyle awaits.",
  "property_applynow_blurb": "Welcome to River's Cove, where comfort meets community in Germantown, WI. Choose from spacious two and three-bedroom apartment homes, complete with modern amenities and delightful views of the serene Menomonee River. Enjoy our courtyard, walking trails, and planned social activities—your perfect home awaits, lease online today!",
  "property_contactus_blurb": "Welcome to River's Cove in Germantown, WI, where your dream home awaits! Choose from spacious two- and three-bedroom floor plans designed for comfort and style. Ready to learn more? Reach out to our leasing team today with any questions—your ideal apartment experience is just a message away!",
  "property_faqs_blurb": "At River's Cove in Germantown, WI, our spacious two and three-bedroom apartments are designed for comfort and style. Curious about what we offer? Dive into our FAQs page for insights that answer your queries and help you envision your new home at our vibrant community.",
  "property_floorplans_blurb": "At River's Cove in Germantown, WI, your ideal living space awaits. Choose from spacious two-bedroom and three-bedroom floor plans designed for comfort and style. Each layout offers a unique ambiance, perfect for every lifestyle. Browse our available apartment homes today and uncover the perfect setting for your new beginning.",
  "property_gallery_blurb": "At River's Cove in Germantown, WI, your ideal lifestyle awaits amidst stunning views of the Menomonee River and Black Stone Creek Golf Course. Enjoy spacious two and three-bedroom apartments featuring modern amenities, such as energy-efficient appliances and private patios. Picture yourself here, where community meets convenience!",
  "property_interactivemap_blurb": "At River's Cove in Germantown, WI, spacious two and three-bedroom apartment homes await you. Revel in amenities like serene walking trails, a cozy fireplace, and controlled access. With the interactive community map, finding your perfect home with stunning views of the Menomonee River has never been easier!",
  "property_pets_blurb": "At River's Cove in Germantown, WI, your pets will thrive! With no weight limits, our community embraces cats and dogs (some breed restrictions apply) alongside other furry and scaly companions. Your pet will enjoy cozy living spaces while you indulge in serene riverside views. Home is where your heart—and pets—are!",
  "property_referafriend_blurb": "At River's Cove in Germantown, WI, your perfect living space awaits, whether it's a cozy two-bedroom or a spacious three-bedroom haven. Share the joy of comfortable living—refer a friend to our vibrant community today and create lasting memories together. Great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to River's Cove in Germantown, WI, where comfort meets convenience! Enjoy spacious two and three-bedroom floor plans designed for your lifestyle. Log in to our resident portal to effortlessly manage rent, schedule maintenance, and access essential community resources—all at your fingertips!",
  "property_reviews_blurb": "At River's Cove in Germantown, WI, residents rave about the welcoming atmosphere and stunning views. One happy tenant shares, “Living here feels like a retreat every day!” Dive into our reviews to see what makes our community a cherished home for so many. Your perfect apartment experience awaits!",
  "property_created_at": "1771543760140",
  "property_scheduletour_blurb": "At River's Cove in Germantown, WI, our thoughtfully designed two- and three-bedroom apartments offer the perfect blend of comfort and style. Schedule a tour today and hear firsthand from our residents about the vibrant community they cherish—your ideal home awaits at River's Cove!",
  "property_thankyou_blurb": "Thank you for reaching out to River's Cove in Germantown, WI! Our spacious two and three-bedroom apartments offer the perfect blend of comfort and modern living. Stay tuned, as a friendly team member will be in touch to guide you on your journey to a new home!",
  "property_virtualtours_blurb": "Welcome to River's Cove in Germantown, WI, where comfort meets style! Choose from our spacious two and three-bedroom floor plans designed for modern living. Experience the charm of our vibrant community—take a virtual tour today and find your perfect home among the serene riverside views!",
  "property_copyright": "2026 All Rights Reserved. River's Cove",
  "property_seo_title_home": "River's Cove Apartments - Comfy Living in Germantown, WI",
  "property_seo_description_home": "River's Cove offers pet-friendly apartments in Germantown, WI with a kayak drop-off, fireplace, and views near Blackstone Creek Golf Club.",
  "property_seo_title_floorplans": "Floor Plans - River's Cove Apartments - Germantown, WI",
  "property_seo_description_floorplans": "Explore two- and three-bedroom floor plans at River's Cove, Germantown, WI. Cozy up by your fireplace or enjoy extra storage and WFH spaces.",
  "property_seo_title_amenities": "Amenities - River's Cove Apartments - Germantown, WI",
  "property_seo_description_amenities": "Discover River's Cove's amenities in Germantown, WI: wood-burning fireplaces, walk-in closets, serene pond, dog park, and more included.",
  "property_seo_title_gallery": "Gallery - River's Cove Apartments - Germantown, WI",
  "property_seo_description_gallery": "Browse the photo gallery for River's Cove Apartments in Germantown, WI, and see stylish kitchens, social community spaces, and river views.",
  "property_seo_title_virtualtours": "Explore River's Cove Virtual Tour - Germantown, WI",
  "property_seo_description_virtualtours": "Explore River's Cove in Germantown, WI with our virtual tour. Picture the apartments, vibe, and welcoming spaces from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | River's Cove Apartments",
  "property_seo_description_interactivemap": "Find your sanctuary at River's Cove in Germantown! Enjoy spacious 2 & 3 bedroom apartments with stunning views, modern amenities, and a vibrant community.",
  "property_seo_title_neighborhood": "Neighborhood - River's Cove Apartments - Germantown, WI",
  "property_seo_description_neighborhood": "Live near Mequon Road and Blackstone Creek Golf Club at River's Cove in Germantown, WI - close to the river and local favorites.",
  "property_seo_title_contact": "Contact River's Cove Apartments - Germantown, WI",
  "property_seo_description_contact": "Connect with River's Cove leasing team in Germantown, WI. Get information, schedule a tour, or ask about floor plans today.",
  "property_seo_title_faqs": "FAQs | Apartments in Germantown, WI",
  "property_seo_description_faqs": "Find answers to your questions about River's Cove in Germantown! Explore amenities, floor plans, and more to see why our community is perfect for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Germantown, WI",
  "property_seo_description_reviews": "Live the serenity at River's Cove in Germantown, WI! Check out resident reviews showcasing our spacious apartments, vibrant amenities, and scenic views.",
  "property_seo_title_applynow": "Apply Now | Apartments in Germantown, WI",
  "property_seo_description_applynow": "Discover comfort at River's Cove in Germantown, WI—spacious 2-3 bedroom apartments with stunning views and modern amenities. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | River's Cove",
  "property_seo_description_residentaccess": "Elevate your River's Cove experience in Germantown! Log in to the resident portal for seamless rent payments, maintenance requests, and exclusive updates.",
  "property_seo_title_referafriend": "Refer A Friend | River's Cove",
  "property_seo_description_referafriend": "Refer a friend to River's Cove in Germantown! Great friends make great neighbors—share the joy of stylish living and community vibes today!",
  "property_seo_title_scheduletour": "Schedule a Tour - River's Cove - Germantown, WI",
  "property_seo_description_scheduletour": "Book a tour of River's Cove Apartments in Germantown, WI. Choose in-person, live virtual, or self-guided tour options to explore your next home.",
  "property_seo_title_privacy": "Privacy Policy | River's Cove",
  "property_seo_description_privacy": "At River's Cove in Germantown, WI, your trust matters. Dive into our privacy policy to see how we protect your data while you enjoy your home sweet home.",
  "property_seo_title_accessibility": "Website Accessibility | River's Cove",
  "property_seo_description_accessibility": "At River's Cove in Germantown, we prioritize digital inclusion with an accessible website. Join our vibrant community where everyone can thrive!",
  "property_seo_title_sitemap": "Sitemap | River's Cove",
  "property_seo_description_sitemap": "Unravel River's Cove in Germantown, WI! Our sitemap guides you through vibrant community offerings, amenities, and your next home sweet home. Dive in!",
  "property_seo_title_thankyou": "Thank You | River's Cove",
  "property_seo_description_thankyou": "Thanks for reaching out to River's Cove in Germantown, WI! Your inquiry is important to us. Expect a prompt reply from our friendly team.",
  "property_seo_title_pets": "Pet Policy | Apartments in Germantown, WI",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764164",
  "amenities": [
    {
      "id": "ec_57900d7b46944d3cf495f276",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258708",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d59fc71cc9eeb49d748ecd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258711",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8df774d545d2a80d8da00214",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258715",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9002d2cd6ca5842ca499b1d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258716",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ce2a8a7d94598677fa1ff42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258717",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d9a3e-5bf5-770b-bee7-7f08b866e737.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, black refrigerator, stove, and dishwasher.",
        "public_id": "019d9a3e-5bf5-770b-bee7-7f08b866e737",
        "storage_key": "property/6767906449167252/019d9a3e-5bf5-770b-bee7-7f08b866e737.webp",
        "width": 2048,
        "height": 1344
      },
      "amenity_image_alt_text": "River's Cove kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47b412f13521798a99951a60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258718",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33c47a54583f956303e1fc2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258723",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40ae166282707ad17e5d647e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258726",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6329faceb94a3e00d64d073",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258729",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8589bf9bfe70d39004641993",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86257389",
      "title": "Cathedral ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e1c02ecfa4f4bae4885d021",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258731",
      "title": "Water and Golf Course Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fbcee8411f41568e4fd86d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258733",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-765d-7584-8a27-d939a5f509cb.webp",
      "amenity_image_media": {
        "alt_text": "Stackable washer and dryer with laundry supplies on shelves above.",
        "public_id": "019d0229-765d-7584-8a27-d939a5f509cb",
        "storage_key": "property/6767906449167252/019d0229-765d-7584-8a27-d939a5f509cb.webp",
        "width": 2048,
        "height": 1322
      },
      "amenity_image_alt_text": "RIver's Cove Laundry",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68b236e424b6e6798177e1bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258734",
      "title": "Linen Closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b1d34e77250cfaf17827f44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258727",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d9a3e-5d52-76a6-ba24-0892781a3d14.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, sofa, and sliding glass door to patio.",
        "public_id": "019d9a3e-5d52-76a6-ba24-0892781a3d14",
        "storage_key": "property/6767906449167252/019d9a3e-5d52-76a6-ba24-0892781a3d14.webp",
        "width": 2048,
        "height": 1375
      },
      "amenity_image_alt_text": "River's Cove Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec7d5fafd6c5eb9b1e397dde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258721",
      "title": "Black or Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77f225680c00fff88c157879",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "123024292",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbbd0c5a8a7cc7b579d77e97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258713",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_160c7334cd41236f35819275",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258714",
      "title": "Serenity Pond",
      "amount": "false",
      "description": "Fishing and Kayaking Access Available",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-9a41-76be-bdc7-bce48eb8f220.webp",
      "amenity_image_media": {
        "alt_text": "Serene pond with lily pads and overhanging tree branches.",
        "public_id": "019d0229-9a41-76be-bdc7-bce48eb8f220",
        "storage_key": "property/6767906449167252/019d0229-9a41-76be-bdc7-bce48eb8f220.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a pond with lily pads and a tree with a house in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_746e033aea17f9e672727aae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "124800173",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdb8eb224043c5e795af519f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258737",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff0b7a258656296013a15aa1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86258738",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-9a31-704a-a7b9-a51c7dd5a67f.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen counter with chairs and dining area.",
        "public_id": "019d0229-9a31-704a-a7b9-a51c7dd5a67f",
        "storage_key": "property/6767906449167252/019d0229-9a31-704a-a7b9-a51c7dd5a67f.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "River's Cove Breakfast Bar",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b12ca95e633a817757e19c0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "86277862",
      "title": "*Select Apartments Only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7681c903c68ecd2d5a12c5f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-570b-7693-ae51-c86e2bd958a2.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and large window overlooking a lake.",
        "public_id": "019d0229-570b-7693-ae51-c86e2bd958a2",
        "storage_key": "property/6767906449167252/019d0229-570b-7693-ae51-c86e2bd958a2.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and stunning lake views through the large patio doors.",
      "link": "false",
      "alt_text": "A bright living room here at River’s Cove with a gray sofa and blue accent pillows, patterned blue rug, and cozy fireplace. Large sliding doors bring in natural light, creating a warm, welcoming atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(1).jpg"
    },
    {
      "id": "ec_fecc0f33b0f6cdc1d3497a78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-570c-739f-aafd-c33e2f0ea229.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, large window overlooking a lake, and modern decor.",
        "public_id": "019d0229-570c-739f-aafd-c33e2f0ea229",
        "storage_key": "property/6767906449167252/019d0229-570c-739f-aafd-c33e2f0ea229.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, a large window with a serene lake view, and stylish modern furnishings.",
      "link": "false",
      "alt_text": "A bright living room here at River’s Cove with a gray sofa and blue accent pillows, patterned blue rug, and cozy fireplace. Large sliding doors open to a scenic lake view, creating a relaxing, welcoming atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(2).jpg"
    },
    {
      "id": "ec_d5803a1eff7771c118c827d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-570e-72ed-a7e2-f5f97fc5aa20.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, white chairs, and a coffee table.",
        "public_id": "019d0229-570e-72ed-a7e2-f5f97fc5aa20",
        "storage_key": "property/6767906449167252/019d0229-570e-72ed-a7e2-f5f97fc5aa20.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa and elegant white accent chairs, perfect for relaxation and entertaining. Notice the decorative mirror and warm wood floors.",
      "link": "false",
      "alt_text": "A welcoming living room here at River’s Cove with a blue sofa, cream accent chairs, and warm wood flooring. Large windows and soft lighting create a bright, comfortable space perfect for relaxing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(3).jpg"
    },
    {
      "id": "ec_7801e53c4b895f33346b709a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-583f-75a8-8f75-34ad290eab8d.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen counter with bar stools in an apartment.",
        "public_id": "019d0229-583f-75a8-8f75-34ad290eab8d",
        "storage_key": "property/6767906449167252/019d0229-583f-75a8-8f75-34ad290eab8d.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A dining area with a round table and chairs, adjacent to a kitchen with a breakfast bar and bar stools. This space offers a comfortable and functional layout.",
      "link": "false",
      "alt_text": "A cozy dining area here at River’s Cove with a round table, brown upholstered chairs, and gold wall accents. The breakfast bar with black stools adds a welcoming space for casual dining and entertaining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(4).jpg"
    },
    {
      "id": "ec_2f3988574a551b9d49cb6c85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-6226-7078-93c9-44369eb70641.webp",
      "image_media": {
        "alt_text": "Kitchen counter with place settings and a bottle of wine",
        "public_id": "019d0229-6226-7078-93c9-44369eb70641",
        "storage_key": "property/6767906449167252/019d0229-6226-7078-93c9-44369eb70641.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Stylish kitchen counter featuring place settings and a bottle of wine, perfect for entertaining.",
      "link": "false",
      "alt_text": "A bright kitchen here at River’s Cove featuring a breakfast bar with decorative blue plates, wine glass, and bottle. Light cabinetry and an open pass-through create a clean, inviting space perfect for casual dining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(5).jpg"
    },
    {
      "id": "ec_9b7719521c6f7793c40cc433",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-62bf-77bc-9542-c1c5be89b936.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, white cabinets, and a sink.",
        "public_id": "019d0229-62bf-77bc-9542-c1c5be89b936",
        "storage_key": "property/6767906449167252/019d0229-62bf-77bc-9542-c1c5be89b936.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A functional kitchen featuring a black refrigerator, ample white cabinetry, a double sink, and a dishwasher. The space is enhanced by decorative items and a welcoming chalkboard sign.",
      "link": "false",
      "alt_text": "A bright kitchen here at River’s Cove featuring white cabinetry, black appliances, and a welcoming layout. A patterned rug and small décor accents add charm, creating a clean, inviting space for everyday cooking and dining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(6).jpg"
    },
    {
      "id": "ec_46528698f922cb1182d008e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-62f9-74cc-8649-1cf46f2c527d.webp",
      "image_media": {
        "alt_text": "A fully furnished bedroom with a queen-sized bed, side tables, and a closet.",
        "public_id": "019d0229-62f9-74cc-8649-1cf46f2c527d",
        "storage_key": "property/6767906449167252/019d0229-62f9-74cc-8649-1cf46f2c527d.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-sized bed, elegant side tables with lamps, and ample closet space.",
      "link": "false",
      "alt_text": "A cozy bedroom here at River’s Cove featuring a plush bed with green bedding, soft carpet, and calming blue walls. Matching lamps and tasteful décor create a warm, inviting retreat perfect for relaxing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(7).jpg"
    },
    {
      "id": "ec_eacc393916a78ece06bdf3eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-639d-73aa-a274-081bbc710b29.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, light blue walls, and a closet.",
        "public_id": "019d0229-639d-73aa-a274-081bbc710b29",
        "storage_key": "property/6767906449167252/019d0229-639d-73aa-a274-081bbc710b29.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-sized bed with decorative pillows and a light blue accent wall. Includes a closet and a framed art piece.",
      "link": "false",
      "alt_text": "A bright bedroom here at River’s Cove featuring a plush bed with green bedding, soft carpet, and calming blue walls. A side table with lamp and framed artwork adds a warm, welcoming touch.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(8).jpg"
    },
    {
      "id": "ec_3eb754d11274659b751d7f3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-6bcb-739d-9dab-cb0a94f7d2f2.webp",
      "image_media": {
        "alt_text": "Bunk beds in a bedroom with a closet and an adjoining bathroom.",
        "public_id": "019d0229-6bcb-739d-9dab-cb0a94f7d2f2",
        "storage_key": "property/6767906449167252/019d0229-6bcb-739d-9dab-cb0a94f7d2f2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring bunk beds, perfect for families or shared living, with ample closet space and easy access to a bathroom.",
      "link": "false",
      "alt_text": "A cozy bedroom here at River’s Cove featuring a wooden bunk bed with gray and yellow bedding, soft carpet, and an open closet, creating a warm, functional, and inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(9).jpg"
    },
    {
      "id": "ec_8b6517bec884ebf217629f6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-6c50-71dd-be16-809c515c61db.webp",
      "image_media": {
        "alt_text": "Bunk beds in a child's bedroom with a papasan chair and dresser.",
        "public_id": "019d0229-6c50-71dd-be16-809c515c61db",
        "storage_key": "property/6767906449167252/019d0229-6c50-71dd-be16-809c515c61db.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Cozy child's bedroom featuring bunk beds, a comfortable papasan chair, and a dark wood dresser. Perfect for families seeking a comfortable living space.",
      "link": "false",
      "alt_text": "A cozy bedroom here at River’s Cove featuring a wooden bunk bed with gray and yellow bedding, soft carpet, and a dark dresser with lamp, creating a warm, comfortable, and inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(10).jpg"
    },
    {
      "id": "ec_40877169d2dd7a919559e9bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-6cc7-7437-83e1-bfe6fac8f69b.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and shower-tub combo. Features a patterned shower curtain and blue towels.",
        "public_id": "019d0229-6cc7-7437-83e1-bfe6fac8f69b",
        "storage_key": "property/6767906449167252/019d0229-6cc7-7437-83e1-bfe6fac8f69b.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity, toilet, and shower-tub combo. The room is decorated with a patterned shower curtain and plush blue towels.",
      "link": "false",
      "alt_text": "A clean bathroom here at River’s Cove featuring a bright vanity, large mirror, patterned shower curtain, and blue accent towels, creating a fresh, inviting, and well-lit space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(11).jpg"
    },
    {
      "id": "ec_5033239c2429562035a29e9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-6e46-74b2-b773-52c630d3bca4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and shower with white curtain.",
        "public_id": "019d0229-6e46-74b2-b773-52c630d3bca4",
        "storage_key": "property/6767906449167252/019d0229-6e46-74b2-b773-52c630d3bca4.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Freshen up in this clean and contemporary bathroom, featuring a spacious vanity, shower, and toilet for your convenience.",
      "link": "false",
      "alt_text": "A bright bathroom here at River’s Cove featuring a wide vanity, large mirror, white shower curtain, and green walls, creating a fresh, clean, and inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(12).jpg"
    },
    {
      "id": "ec_8d2564abd79261a219526779",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-756b-75b8-ae34-be90a7540e7b.webp",
      "image_media": {
        "alt_text": "Walk-in closet with wire shelving and wooden hangers",
        "public_id": "019d0229-756b-75b8-ae34-be90a7540e7b",
        "storage_key": "property/6767906449167252/019d0229-756b-75b8-ae34-be90a7540e7b.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring built-in wire shelving and ample space for storage.",
      "link": "false",
      "alt_text": "A spacious walk-in closet here at River’s Cove featuring soft carpet, wire shelving, and organized storage, creating a bright, clean, and practical space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(13).jpg"
    },
    {
      "id": "ec_5d27c7dbf624145a41ee7991",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-765d-7584-8a27-d939a5f509cb.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer with laundry supplies on shelves above.",
        "public_id": "019d0229-765d-7584-8a27-d939a5f509cb",
        "storage_key": "property/6767906449167252/019d0229-765d-7584-8a27-d939a5f509cb.webp",
        "width": 2048,
        "height": 1322
      },
      "title": "Apartment",
      "description": "In-unit laundry area with washer, dryer, and shelving for supplies.",
      "link": "false",
      "alt_text": "A convenient laundry room here at River’s Cove featuring full-size washer and dryer, open shelving, and organized storage, creating a clean, practical, and functional space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(14).jpg"
    },
    {
      "id": "ec_25cd926993a9d91caee78c48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-7895-77ad-9fd0-bdf059e64677.webp",
      "image_media": {
        "alt_text": "Apartment buildings with garages and cars parked in front.",
        "public_id": "019d0229-7895-77ad-9fd0-bdf059e64677",
        "storage_key": "property/6767906449167252/019d0229-7895-77ad-9fd0-bdf059e64677.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring garages and cars, set against a backdrop of trees and a blue sky with clouds.",
      "link": "false",
      "alt_text": "A welcoming exterior here at River’s Cove featuring attached garages, open green space, and a well-maintained setting, creating a quiet, spacious, and inviting community atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(15).jpg"
    },
    {
      "id": "ec_8f20400459c1b80647e52da4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-7854-72b4-893a-1012cb404cc1.webp",
      "image_media": {
        "alt_text": "River's Cove Apartment Homes sign with buildings and garages in the background.",
        "public_id": "019d0229-7854-72b4-893a-1012cb404cc1",
        "storage_key": "property/6767906449167252/019d0229-7854-72b4-893a-1012cb404cc1.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Welcome to River's Cove Apartment Homes, featuring a prominent community sign and well-maintained buildings with attached garages.",
      "link": "false",
      "alt_text": "A welcoming exterior here at River’s Cove featuring the community entrance sign, attached garages, and landscaped surroundings, creating a charming, well-kept, and inviting first impression.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Rivers_Cove_Favorites%20(16).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_dd13b70e-251f-4cc9-80be-849c368996e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "China Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "N112W16560 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Laid-back, sizable spot featuring all-you-can-eat Chinese staples plus sushi & hibachi fare.",
      "poi_long_description": "Laid-back, sizable spot featuring all-you-can-eat Chinese staples plus sushi & hibachi fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-a8d4-70ca-83aa-7cd2514617a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-a8d4-70ca-83aa-7cd2514617a8",
        "storage_key": "property/6767906449167252/019d0229-a8d4-70ca-83aa-7cd2514617a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichinakitchen.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12670514745378810447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-kitchen",
      "poi_latitude": "43.2214981",
      "poi_longitude": "-88.1149951",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-250-1188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XvucBT8BIgRTyqnlwe21q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_7b740972-9302-482a-97e9-399406a7256d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Hung Hao",
      "poi_type": "Restaurants",
      "poi_address": "N112W15800 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Casual Chinese restaurant featuring an expansive menu of favorites for eat-in or takeout.",
      "poi_long_description": "Casual Chinese restaurant featuring an expansive menu of favorites for eat-in or takeout.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hunghaowi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=373263802166827603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hung-hao",
      "poi_latitude": "43.222059",
      "poi_longitude": "-88.1061361",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-3968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdyou77-BIgRU1qqT3MZLgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_0e03a9de-c2ed-4a41-96d2-3eb34aabe594",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Chris Greene Inc",
      "poi_type": "Restaurants",
      "poi_address": "N112W15251 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-a84e-70d3-8479-2886c1b5de9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-a84e-70d3-8479-2886c1b5de9d",
        "storage_key": "property/6767906449167252/019d0229-a84e-70d3-8479-2886c1b5de9d.webp",
        "width": 1280,
        "height": 416
      },
      "poi_business_url": "https://chrisgreeneinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17787197664908582302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chris-greene-inc",
      "poi_latitude": "43.2207544",
      "poi_longitude": "-88.09910789999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-253-1399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97EmTcb_BIgRnp2IHgnS2PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_cdba17e7-9a36-4e7d-9fae-433476c2f6e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Old Germantown",
      "poi_type": "Restaurants",
      "poi_address": "W148N12696 Pleasant View Dr, Germantown, WI 53022, USA",
      "poi_short_description": "Casual pizzeria & beer garden featuring smoked and fresh sausages on wood-fired pies, plus craft beer.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.oldgermantown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6505177145074188802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-germantown",
      "poi_latitude": "43.248658",
      "poi_longitude": "-88.0896441",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 262-345-5961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzCbtS35BIgRAgIjxSUIR1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_abfaba14-4beb-4068-9813-04d81a7fab3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Marko's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "W156N9664 Pilgrim Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Casual pizzeria offering made-to-order pies with a variety of toppings, plus beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://markospizzas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2357799630168876011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "markos-pizza",
      "poi_latitude": "43.1930216",
      "poi_longitude": "-88.1021392",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-251-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwM5iGP-BIgR62PDf0WWuCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f2e474f5-55a8-40ba-aa2e-2ba2df07d781",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Pizza Hut",
      "poi_type": "Restaurants",
      "poi_address": "North 112 W, 15800 Mequon Rd Suite 13, Germantown, WI 53022, USA",
      "poi_short_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_long_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-a86b-75e9-b4b4-1f93bb60f110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-a86b-75e9-b4b4-1f93bb60f110",
        "storage_key": "property/6767906449167252/019d0229-a86b-75e9-b4b4-1f93bb60f110.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.pizzahut.com/wi/germantown/north-112-w-15800-mequon-rd?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=299639",
      "poi_directions_map_url": "https://maps.google.com/?cid=17980701496195902895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-hut",
      "poi_latitude": "43.222307",
      "poi_longitude": "-88.1073684",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-251-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdyou77-BIgRr20Xtb5IiPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "custom_297f98b9-a796-41c8-99e4-dab12346697f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "N112W16510 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-a889-768f-bdfa-ece60a582406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-a889-768f-bdfa-ece60a582406",
        "storage_key": "property/6767906449167252/019d0229-a889-768f-bdfa-ece60a582406.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/9593/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1846351899072404032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "43.22147",
      "poi_longitude": "-88.11448",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-253-1308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1d1-723b-9f49-8c51ae31eb0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1d1-723b-9f49-8c51ae31eb0c",
        "storage_key": "property/6767906449167252/019d0229-f1d1-723b-9f49-8c51ae31eb0c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJM810WMH-BIgRQBqUEkWPnxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c8aa7fd5-4184-4525-bd9d-2bd5217a4776",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "N92 W17512 County Line Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_long_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ad11-74df-be79-a4dc942e463e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-ad11-74df-be79-a4dc942e463e",
        "storage_key": "property/6767906449167252/019d0229-ad11-74df-be79-a4dc942e463e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcdonalds.com/us/en-us/location/WI/GERMANTOWN/N92-W17512-COUNTY-LINE-ROAD/4307.html?cid=RF:YXT:GMB::Clicks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12040945795687459403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcdonalds",
      "poi_latitude": "43.1935233",
      "poi_longitude": "-88.1274473",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-255-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzwQm1T-BIgRSyqvz2cIGqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_61c90160-5946-408f-876b-269b0943e901",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Wendy's",
      "poi_type": "Restaurants",
      "poi_address": "N96w17600 County Line Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_long_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-aec5-755f-80f9-292f83075563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-aec5-755f-80f9-292f83075563",
        "storage_key": "property/6767906449167252/019d0229-aec5-755f-80f9-292f83075563.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.wendys.com/united-states/wi/germantown/n96w17600-county-line-rd?utm_source=Yext&utm_medium=Google_My_Business&utm_campaign=Local_Search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13563181536534086184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendys",
      "poi_latitude": "43.1934129",
      "poi_longitude": "-88.12848199999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-255-1315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3D69Fv-BIgRKEJAJb8ZOrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_721cf8b4-4e80-4e5b-a037-df820991c82f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Sports Corner Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "12793 Fond du Lac Ave, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ae51-7121-9508-ef8b94833669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-ae51-7121-9508-ef8b94833669",
        "storage_key": "property/6767906449167252/019d0229-ae51-7121-9508-ef8b94833669.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6771804999582410393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sports-corner-bar--grill",
      "poi_latitude": "43.2498454",
      "poi_longitude": "-88.14280769999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 262-677-1994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1dd-77aa-8d9a-57c855a20ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1dd-77aa-8d9a-57c855a20ed9",
        "storage_key": "property/6767906449167252/019d0229-f1dd-77aa-8d9a-57c855a20ed9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJfL2NcT4BIgRmeZSwMRI-l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ecb2e9f5-7581-44fb-ba2d-ebb5af4bd8c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Jimmy John's",
      "poi_type": "Restaurants",
      "poi_address": "N112 W16268 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Counter-serve chain specializing in sub & club sandwiches, plus signature potato chips.",
      "poi_long_description": "Counter-serve chain specializing in sub & club sandwiches, plus signature potato chips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-aec5-755f-80f9-2f66b2d5ecf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-aec5-755f-80f9-2f66b2d5ecf0",
        "storage_key": "property/6767906449167252/019d0229-aec5-755f-80f9-2f66b2d5ecf0.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://locations.jimmyjohns.com/wi/germantown/sandwiches-123.html?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAyNDA4NDU1OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17114955711804782494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jimmy-johns",
      "poi_latitude": "43.2220333",
      "poi_longitude": "-88.11146079999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-502-3505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEw7QQNz-BIgRnreqfIqJhO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_15fd992f-1d39-43e0-bb29-613a1502fdc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Relish Supper Club",
      "poi_type": "Restaurants",
      "poi_address": "N116W15841 Main St, Germantown, WI 53022, USA",
      "poi_short_description": "Wisconsin-style restaurant serving steaks, seafood and ribs, plus cocktails and beer.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://relishsupperclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16995256761366032507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "relish-supper-club",
      "poi_latitude": "43.2281031",
      "poi_longitude": "-88.1062165",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-415-7043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuzbtHDX_BIgRezDHz_pH2-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_afdb7763-af79-48ed-ace6-a23a7ac5c127",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Von Rothenburg Bier Stube",
      "poi_type": "Restaurants",
      "poi_address": "N116W15863 Main St, Germantown, WI 53022, USA",
      "poi_short_description": "German cooking & draft beers go together in traditional, bi-level Bavarian environs with a garden.",
      "poi_long_description": "German cooking & draft beers go together in traditional, bi-level Bavarian environs with a garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b3b8-753a-a2e5-1fe8cfa04071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b3b8-753a-a2e5-1fe8cfa04071",
        "storage_key": "property/6767906449167252/019d0229-b3b8-753a-a2e5-1fe8cfa04071.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vrbierstube.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12258647087386598391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "von-rothenburg-bier-stube",
      "poi_latitude": "43.228144",
      "poi_longitude": "-88.10656499999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdxfDbf-BIgR9xuOrpN2H6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_a13da346-dc38-4d32-9c18-ab8846266339",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Tiny T's",
      "poi_type": "Restaurants",
      "poi_address": "W157N11638 Fond du Lac Ave, Germantown, WI 53022, USA",
      "poi_short_description": "Family-owned taproom with pool tables, dart boards and slots for locals, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b3c1-77bd-b035-5c74460f26e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b3c1-77bd-b035-5c74460f26e9",
        "storage_key": "property/6767906449167252/019d0229-b3c1-77bd-b035-5c74460f26e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7292108645218276514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiny-ts",
      "poi_latitude": "43.2287728",
      "poi_longitude": "-88.10556",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-251-4994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1dd-77aa-8d9a-57c855a20ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1dd-77aa-8d9a-57c855a20ed9",
        "storage_key": "property/6767906449167252/019d0229-f1dd-77aa-8d9a-57c855a20ed9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1dcIbf-BIgRolTKdS3GMmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_9e214858-6a75-4621-9a97-00bef09267dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Country Inn & Suites by Radisson, Germantown, WI",
      "poi_type": "Restaurants",
      "poi_address": "W 188 North, 11020 Maple Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Down-to-earth hotel with an indoor pool & a fitness room, plus a free breakfast buffet.",
      "poi_long_description": "Down-to-earth hotel with an indoor pool & a fitness room, plus a free breakfast buffet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b3e5-7275-8e53-171a1b42d00e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b3e5-7275-8e53-171a1b42d00e",
        "storage_key": "property/6767906449167252/019d0229-b3e5-7275-8e53-171a1b42d00e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.choicehotels.com/wisconsin/germantown/country-inn-suites-hotels/wi483?mc=llgoxxpx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9755142146173315806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-inn--suites-by-radisson-germantown-wi",
      "poi_latitude": "43.2177398",
      "poi_longitude": "-88.14139279999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-293-6948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f51c-755d-8f49-c8f6421b73bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f51c-755d-8f49-c8f6421b73bb",
        "storage_key": "property/6767906449167252/019d0229-f51c-755d-8f49-c8f6421b73bb.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJAcQ2ZAn_BIgR3ioa1Bg6YYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_c18c014a-faff-4e3d-a261-8cd994081790",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Sendik's Food Market Germantown",
      "poi_type": "Shopping & Retail",
      "poi_address": "N112W15800 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Grocery store with a deli & bakery, plus a selection of wine & takeaway fare, including sushi.",
      "poi_long_description": "Grocery store with a deli & bakery, plus a selection of wine & takeaway fare, including sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b524-7638-9a0a-288775fb91a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b524-7638-9a0a-288775fb91a6",
        "storage_key": "property/6767906449167252/019d0229-b524-7638-9a0a-288775fb91a6.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.sendiks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7785945006006105673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sendiks-food-market-germantown",
      "poi_latitude": "43.22203460000001",
      "poi_longitude": "-88.1052443",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-9525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f55d-763e-bb7c-c6f57b3d7632",
        "storage_key": "property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRQEsL7-BIgRSXa4M7s7DWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f624690d-a4f0-4160-8bca-dce2b0b27768",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Pick 'n Save",
      "poi_type": "Shopping & Retail",
      "poi_address": "N112W16200 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Supermarket, pharmacy and bakery providing produce, meats, seafood and wines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b9ae-752c-bb7f-b56136001960.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b9ae-752c-bb7f-b56136001960",
        "storage_key": "property/6767906449167252/019d0229-b9ae-752c-bb7f-b56136001960.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.picknsave.com/stores/grocery/wi/germantown/pns-germantown/534/00357?cid=loc_53400357_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349730902601834365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pick-n-save",
      "poi_latitude": "43.2221429",
      "poi_longitude": "-88.1103252",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-253-0841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f55d-763e-bb7c-c6f57b3d7632",
        "storage_key": "property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw48_Tcf-BIgRfR9Xd87rmyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_88e5afea-5f58-4bb3-8f87-ea72013bde05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "N96w18838 County Line Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-bbaf-770b-b558-d7683e250787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-bbaf-770b-b558-d7683e250787",
        "storage_key": "property/6767906449167252/019d0229-bbaf-770b-b558-d7683e250787.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.aldi.us/stores/l/wi/germantown/n96w18838-county-line-road/f773",
      "poi_directions_map_url": "https://maps.google.com/?cid=14201409492128515504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "43.192989",
      "poi_longitude": "-88.143429",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f55d-763e-bb7c-c6f57b3d7632",
        "storage_key": "property/6767906449167252/019d0229-f55d-763e-bb7c-c6f57b3d7632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSFZD6T_BIgRsEUu2LCKFcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_047d9598-cf63-4f81-9dc4-3a6bb5845605",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "W190n9855 Appleton Ave, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-b9cc-7163-b251-2465fb358df9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-b9cc-7163-b251-2465fb358df9",
        "storage_key": "property/6767906449167252/019d0229-b9cc-7163-b251-2465fb358df9.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1515-germantown-wi/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11456090872893795911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "43.196383",
      "poi_longitude": "-88.1465412",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-255-1285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f573-7192-a99a-70efce6bd2ac",
        "storage_key": "property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3UcbNXv_BIgRR-5tsfM1_J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_56563778-b138-4ff5-92e3-bce59bcf84e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "W162N9235 Pershing Ave, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-bd17-750d-ba94-4c6b0e0ebae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-bd17-750d-ba94-4c6b0e0ebae2",
        "storage_key": "property/6767906449167252/019d0229-bd17-750d-ba94-4c6b0e0ebae2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/menomonee-falls-WI-1209.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10076529436813296502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "43.1853084",
      "poi_longitude": "-88.1121399",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 262-946-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f573-7192-a99a-70efce6bd2ac",
        "storage_key": "property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkV3amkb-BIgRdgMGkiIG14s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_722fae77-d5b4-4156-b543-3ac7d686ac71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "W156n11261 Pilgrim Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-w156n11261+pilgrim+rd-germantown-wi-53022/id=5427",
      "poi_directions_map_url": "https://maps.google.com/?cid=10222394987633321749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "43.222059",
      "poi_longitude": "-88.1041766",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 262-253-9720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_096Zb-BIgRFSeepxQ-3Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8fe515c2-33e2-42a2-94f7-51e5301a9201",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Kwik Trip",
      "poi_type": "Shopping & Retail",
      "poi_address": "N112W18741 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.kwiktrip.com/locator/store?id=631",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052358612444978323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kwik-trip",
      "poi_latitude": "43.2196542",
      "poi_longitude": "-88.1418723",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-253-1007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f575-7429-bf4f-bbaddb7a27c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f575-7429-bf4f-bbaddb7a27c1",
        "storage_key": "property/6767906449167252/019d0229-f575-7429-bf4f-bbaddb7a27c1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYxmNAtWBIgRkxyf-eUmgYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_f599507b-0d45-496f-a4fe-31a6be015121",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "W164n11233 Squire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_long_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-bfef-72fc-b9ed-5b3091b77dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-bfef-72fc-b9ed-5b3091b77dc8",
        "storage_key": "property/6767906449167252/019d0229-bfef-72fc-b9ed-5b3091b77dc8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.speedway.com/locations/WI/Germantown/W164N11233-Squire-Drive?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1799377425029429907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "43.2215071",
      "poi_longitude": "-88.1137043",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-502-0428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f575-7429-bf4f-bbaddb7a27c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f575-7429-bf4f-bbaddb7a27c1",
        "storage_key": "property/6767906449167252/019d0229-f575-7429-bf4f-bbaddb7a27c1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxvfRcH-BIgRk3q8Czys-Bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_6c1e9f42-5aa4-41e6-bfd5-b1ee8e59446d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "N95 W, 17707 Shady Ln, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.target.com/sl/menomonee-falls/863",
      "poi_directions_map_url": "https://maps.google.com/?cid=3493359873266796366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "43.1890006",
      "poi_longitude": "-88.1295736",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 262-255-6119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f573-7192-a99a-70efce6bd2ac",
        "storage_key": "property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1QJ0lzb-BIgRTserzkvoejA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_083c1ac8-5d81-4015-96a5-60af2eaeb924",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "N95 W18000, Appleton Ave, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.kohls.com/stores/wi/menomoneefalls-101.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2124174936802643986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "43.1909127",
      "poi_longitude": "-88.133352",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 262-251-9075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f573-7192-a99a-70efce6bd2ac",
        "storage_key": "property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMysM6RICBYgREtDoxNmVeh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_092be70b-8f5b-428e-86f8-624523ddce80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Germantown High School",
      "poi_type": "Education",
      "poi_address": "W180N11501 N River Ln, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gsdwi.org/ghs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5856159810095107446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "germantown-high-school",
      "poi_latitude": "43.2262316",
      "poi_longitude": "-88.13460239999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-253-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM7TQ24L-BIgRdk2j7FFCRVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a0f677f1-ece1-448a-b9cf-617bda36aa4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Kennedy Middle School",
      "poi_type": "Education",
      "poi_address": "N 118, W15860 Williams Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-bff6-74dd-882f-58d27a2b9519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-bff6-74dd-882f-58d27a2b9519",
        "storage_key": "property/6767906449167252/019d0229-bff6-74dd-882f-58d27a2b9519.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gsdwi.org/kms",
      "poi_directions_map_url": "https://maps.google.com/?cid=7557921596064610340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennedy-middle-school",
      "poi_latitude": "43.232706",
      "poi_longitude": "-88.1077873",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 262-253-3450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1R38TrT-BIgRJDiv5aUh42g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_001a7f28-2b81-4f61-aa91-e58c204f1b78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "MacArthur Elementary School",
      "poi_type": "Education",
      "poi_address": "W154N11492 Fond du Lac Ave, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gsdwi.org/macarthur",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866118513466814755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarthur-elementary-school",
      "poi_latitude": "43.2275812",
      "poi_longitude": "-88.101986",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 262-253-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBeRxY7D-BIgRIzEklgHth0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9533d529-29df-4a70-82e4-e297606fdb23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Rockfield Elementary",
      "poi_type": "Education",
      "poi_address": "N132W18473 Rockfield Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gsdwi.org/rockfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=9069831083906072151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockfield-elementary",
      "poi_latitude": "43.25671759999999",
      "poi_longitude": "-88.13708779999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 262-628-7622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe5Qi8SX_BIgRV34EGVGD3n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4f732833-8881-4e56-ba0b-f5358d898f7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "County Line Elementary School",
      "poi_type": "Education",
      "poi_address": "W159 N9939, W159N9939 Butternut Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gsdwi.org/o/county-line",
      "poi_directions_map_url": "https://maps.google.com/?cid=12701724116776378185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "county-line-elementary-school",
      "poi_latitude": "43.1980153",
      "poi_longitude": "-88.1074429",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-253-3465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaXNefor-BIgRSd93n8mWRbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_68a83f60-3d60-4cd3-8714-14438a65ab1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "St Boniface School",
      "poi_type": "Education",
      "poi_address": "W204N11968 Goldendale Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stbonifacewi.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3577711731038009668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-boniface-school",
      "poi_latitude": "43.2349128",
      "poi_longitude": "-88.16155979999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-628-1955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1bxXCVP_BIgRRLlEJd2VpjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_66a5c3a4-2b62-4925-9236-6cec64203e4a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Momentum Early Learning",
      "poi_type": "Education",
      "poi_address": "W175N11037 Stonewood Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-c257-72ef-a494-6d286ba32be0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-c257-72ef-a494-6d286ba32be0",
        "storage_key": "property/6767906449167252/019d0229-c257-72ef-a494-6d286ba32be0.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://momentumearlylearning.com/germantown-early-education-location",
      "poi_directions_map_url": "https://maps.google.com/?cid=10646290216582877807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "momentum-early-learning",
      "poi_latitude": "43.2177123",
      "poi_longitude": "-88.1272151",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-415-8047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX_QWVd7-BIgRb5Ijp4s4v5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6d9cb80c-fd6c-490d-b97b-a707466aa463",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Willow Creek Child Care Center",
      "poi_type": "Education",
      "poi_address": "W164N11310 Squire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-c528-7328-a567-17105c6bebf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-c528-7328-a567-17105c6bebf4",
        "storage_key": "property/6767906449167252/019d0229-c528-7328-a567-17105c6bebf4.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.willowcreekchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4812334225564408460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-creek-child-care-center",
      "poi_latitude": "43.2229171",
      "poi_longitude": "-88.1125141",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-255-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvUHh28b-BIgRjJo4N3vYyEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6a8fdb38-1d3b-4250-8f01-4309dd1e0394",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Germantown Mequon Road KinderCare",
      "poi_type": "Education",
      "poi_address": "Mequon Rd N112 W17060, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-c639-7048-9ed9-750befb5b9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-c639-7048-9ed9-750befb5b9e2",
        "storage_key": "property/6767906449167252/019d0229-c639-7048-9ed9-750befb5b9e2.webp",
        "width": 1280,
        "height": 927
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/germantown/wi/301963?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTE4NjkyNTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7022175527581928939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "germantown-mequon-road-kindercare",
      "poi_latitude": "43.2214639",
      "poi_longitude": "-88.12100170000001",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 262-251-5324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRzuq9tr_BIgR603272_Hc2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_7fbb8441-4d20-4f9d-baaa-9c3030a12da3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Concordia University Wisconsin",
      "poi_type": "Education",
      "poi_address": "12800 N Lake Shore Dr, Mequon, WI 53097, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-c622-775e-b892-6d3b7f10edde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-c622-775e-b892-6d3b7f10edde",
        "storage_key": "property/6767906449167252/019d0229-c622-775e-b892-6d3b7f10edde.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.cuw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10921775185612896908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concordia-university-wisconsin",
      "poi_latitude": "43.2541994",
      "poi_longitude": "-87.915531",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 262-243-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSzk0P5XmBIgRjPohT6rwkZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e7a54178-4422-47a1-9adb-faa00acf45b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Germantown School District Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "W180N11501 N River Ln, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-c8cb-722f-8c02-d2991c15f992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-c8cb-722f-8c02-d2991c15f992",
        "storage_key": "property/6767906449167252/019d0229-c8cb-722f-8c02-d2991c15f992.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gsdwi.org/o/pac",
      "poi_directions_map_url": "https://maps.google.com/?cid=796576499853879685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "germantown-school-district-performing-arts-center",
      "poi_latitude": "43.2272568",
      "poi_longitude": "-88.1344817",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-253-3421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_xlGOH_BIgRhek2LhsCDgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_2ce061c6-3dcb-4452-b8c1-108c7ff04106",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Stix Golf Entertainment",
      "poi_type": "Entertainment",
      "poi_address": "W164N11271 Squire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "Golf-game simulator venue with a bar, beer garden, bag toss and ping-pong.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-cae3-77df-a472-32b4404c5473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-cae3-77df-a472-32b4404c5473",
        "storage_key": "property/6767906449167252/019d0229-cae3-77df-a472-32b4404c5473.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "http://stixgolfbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=380604021721524758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stix-golf-entertainment",
      "poi_latitude": "43.2222398",
      "poi_longitude": "-88.11502829999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-415-7513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9ed-74f0-85dd-048c07812c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9ed-74f0-85dd-048c07812c34",
        "storage_key": "property/6767906449167252/019d0229-f9ed-74f0-85dd-048c07812c34.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6XDBMT-BIgRFurLWlctSAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_golf_course"
    },
    {
      "id": "custom_5541fc4f-0933-450f-8797-92538946ede1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "A Kid At Heart Playland",
      "poi_type": "Entertainment",
      "poi_address": "W188N10707 Maple Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Indoor play space featuring a jungle gym, a racetrack, and other toys, plus a space for adults.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://akidatheartplayland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13675764820921061406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-kid-at-heart-playland",
      "poi_latitude": "43.212323",
      "poi_longitude": "-88.1441333",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-293-3046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bsoerf_BIgRHpDItqUTyr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_b5e07470-b06c-4c52-a17e-1e222ea0f085",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Robert's Frozen Custard",
      "poi_type": "Entertainment",
      "poi_address": "N112W16040 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Hefty burgers & ice cream desserts offered in a contemporary eatery with outdoor picnic tables.",
      "poi_long_description": "Hefty burgers & ice cream desserts offered in a contemporary eatery with outdoor picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-cd05-73df-b34e-1603f0e24f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-cd05-73df-b34e-1603f0e24f06",
        "storage_key": "property/6767906449167252/019d0229-cd05-73df-b34e-1603f0e24f06.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "http://www.robertsfrozencustard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15855440180064598466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roberts-frozen-custard",
      "poi_latitude": "43.2214898",
      "poi_longitude": "-88.1085062",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-250-1683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e1-77c8-bc21-7053752bea08",
        "storage_key": "property/6767906449167252/019d0229-f1e1-77c8-bc21-7053752bea08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_XgN7_-BIgRwrk0itbWCdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_17a95363-d905-4685-9a51-67a6289210a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Village Bowl & Social",
      "poi_type": "Entertainment",
      "poi_address": "N86W18330 Main St, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Entertainment center featuring 26 lanes of bowling, plus a restaurant, banquet facilities, and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-cf9d-72ce-bb83-e24aef30596d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-cf9d-72ce-bb83-e24aef30596d",
        "storage_key": "property/6767906449167252/019d0229-cf9d-72ce-bb83-e24aef30596d.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.villagebowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6748322916502892850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-bowl--social",
      "poi_latitude": "43.17600969999999",
      "poi_longitude": "-88.1375856",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 262-255-1580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_80kvMj_BIgRMnHIO_Dbpl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_3c89b2a6-c698-4144-aa8b-40aa207b3688",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Marcus Menomonee Falls Cinema",
      "poi_type": "Entertainment",
      "poi_address": "W180 N9393 Premier Ln, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Theater chain for mainstream films; most offer enhanced picture & sound & expanded dining options.",
      "poi_long_description": "Theater chain for mainstream films; most offer enhanced picture & sound & expanded dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d20d-7313-9fea-8a2737b8beef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d20d-7313-9fea-8a2737b8beef",
        "storage_key": "property/6767906449167252/019d0229-d20d-7313-9fea-8a2737b8beef.webp",
        "width": 600,
        "height": 600
      },
      "poi_business_url": "https://www.marcustheatres.com/theatre-locations/menomonee-falls-cinema-menomonee-falls",
      "poi_directions_map_url": "https://maps.google.com/?cid=11804850879345911292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcus-menomonee-falls-cinema",
      "poi_latitude": "43.185751",
      "poi_longitude": "-88.1341764",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 262-502-9071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f4-7219-bdc9-d25adee43ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f4-7219-bdc9-d25adee43ad8",
        "storage_key": "property/6767906449167252/019d0229-f9f4-7219-bdc9-d25adee43ad8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZP3e7H_BIgR_OXeeVRB06M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_bfb373f7-c1c8-4288-bd94-614f757aed8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Mequon Nature Preserve",
      "poi_type": "Entertainment",
      "poi_address": "8200 W County Line Rd, Mequon, WI 53097, USA",
      "poi_short_description": "Restored natural habitat with trails, wetlands & fields, plus an observation tower.",
      "poi_long_description": "Restored natural habitat with trails, wetlands & fields, plus an observation tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d365-7425-8165-f7beedba4053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d365-7425-8165-f7beedba4053",
        "storage_key": "property/6767906449167252/019d0229-d365-7425-8165-f7beedba4053.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://mequonnaturepreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11026609399962131386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mequon-nature-preserve",
      "poi_latitude": "43.1932437",
      "poi_longitude": "-88.0101772",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 262-242-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbb0r89T8BIgRutu56dNiBpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b2eff3ef-d2f6-44b2-baa3-544a74597883",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Rivoli Theatre",
      "poi_type": "Entertainment",
      "poi_address": "W62N567 Washington Ave, Cedarburg, WI 53012, USA",
      "poi_short_description": "Historic single-screen theater showing mostly family-friendly, 2nd-run features.",
      "poi_long_description": "Historic single-screen theater showing mostly family-friendly, 2nd-run features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d589-779b-91fa-e98dbd098d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d589-779b-91fa-e98dbd098d18",
        "storage_key": "property/6767906449167252/019d0229-d589-779b-91fa-e98dbd098d18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rivoliofcedarburg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15460106507694067487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivoli-theatre",
      "poi_latitude": "43.2961957",
      "poi_longitude": "-87.98755799999999",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f4-7219-bdc9-d25adee43ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f4-7219-bdc9-d25adee43ad8",
        "storage_key": "property/6767906449167252/019d0229-f9f4-7219-bdc9-d25adee43ad8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSjt9GvlBIgRH0_PJPVUjdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_17cb9044-3792-47d3-b9c4-4e7f08e1085a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Ascension Columbia St. Mary's - Germantown",
      "poi_type": "Health and Wellness",
      "poi_address": "N112 W15415 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://healthcare.ascension.org/locations/wisconsin/wimil/germantown-ascension-columbia-st-marys?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10558985337654841636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-columbia-st-marys---germantown",
      "poi_latitude": "43.2203612",
      "poi_longitude": "-88.1007193",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-fd18-746e-872c-aaf5721ae1ee",
        "storage_key": "property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEw7QQNz-BIgRJJF5fzgNiZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_a13514f6-c75c-4a84-9e7b-1d521d72612e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Germantown Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "W168 N11237 Western Ave, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d556-7378-9f70-1a277b2dd90b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d556-7378-9f70-1a277b2dd90b",
        "storage_key": "property/6767906449167252/019d0229-d556-7378-9f70-1a277b2dd90b.webp",
        "width": 595,
        "height": 347
      },
      "poi_business_url": "https://www.froedtert.com/locations/health-center/germantown-health-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7833001799543566427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "germantown-health-center",
      "poi_latitude": "43.2215411",
      "poi_longitude": "-88.11869809999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-253-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6ZcnsT-BIgRWzDKuqJptGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8d7528b3-736f-42c0-8c70-7183f55f6a4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Ascension Wisconsin Hospital - Menomonee Falls",
      "poi_type": "Health and Wellness",
      "poi_address": "N88W14275 Main St Fl 2, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d696-75ff-b619-e1404969c11b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d696-75ff-b619-e1404969c11b",
        "storage_key": "property/6767906449167252/019d0229-d696-75ff-b619-e1404969c11b.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/wisconsin/wimil/menomonee-falls-ascension-wisconsin-hospital-menomonee-falls?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10187533682638783980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-wisconsin-hospital---menomonee-falls",
      "poi_latitude": "43.1777266",
      "poi_longitude": "-88.0876974",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 262-415-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-fd18-746e-872c-aaf5721ae1ee",
        "storage_key": "property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIe94-zv9BIgR7AUDk-hjYY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d641430e-1a00-4c29-8fae-bac171764a5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Froedtert Menomonee Falls Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "W180 N8085, Town Hall Rd, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d7f6-75a1-be8d-812f42430652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d7f6-75a1-be8d-812f42430652",
        "storage_key": "property/6767906449167252/019d0229-d7f6-75a1-be8d-812f42430652.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.froedtert.com/locations/hospital/menomonee-falls-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12627641180611893001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "froedtert-menomonee-falls-hospital",
      "poi_latitude": "43.1643867",
      "poi_longitude": "-88.1380032",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 262-251-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-fd18-746e-872c-aaf5721ae1ee",
        "storage_key": "property/6767906449167252/019d0229-fd18-746e-872c-aaf5721ae1ee.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0e4ELtf_BIgRCVd36b9kPq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f1b09b0e-3551-4be8-ab51-78baaad50267",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "N83w15701 Appleton Ave, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-d9c6-74d0-908e-b42e6c83a422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-d9c6-74d0-908e-b42e6c83a422",
        "storage_key": "property/6767906449167252/019d0229-d9c6-74d0-908e-b42e6c83a422.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-n83w15701+appleton+ave-menomonee+falls-wi-53051/id=5002",
      "poi_directions_map_url": "https://maps.google.com/?cid=13020316035885145267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "43.1695106",
      "poi_longitude": "-88.1052692",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 262-251-3890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-fdba-76ae-a2f0-b5a111e8e66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-fdba-76ae-a2f0-b5a111e8e66f",
        "storage_key": "property/6767906449167252/019d0229-fdba-76ae-a2f0-b5a111e8e66f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIz6kTxf-BIgRs5xBNnN0sbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6105d051-bb12-4fd8-9e83-42a30212c338",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "W190n9855 Appleton Ave, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-da0f-721c-a9bf-db636b7dfd8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-da0f-721c-a9bf-db636b7dfd8e",
        "storage_key": "property/6767906449167252/019d0229-da0f-721c-a9bf-db636b7dfd8e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1515-germantown-wi/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13098449880064013832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "43.196006",
      "poi_longitude": "-88.1457078",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-255-5351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-fdba-76ae-a2f0-b5a111e8e66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-fdba-76ae-a2f0-b5a111e8e66f",
        "storage_key": "property/6767906449167252/019d0229-fdba-76ae-a2f0-b5a111e8e66f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBx3xJqf_BIgRCDZ5ccQKx7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_fc12a3c7-e5c8-4269-b662-0e168b79dfa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "W175N11162 Stonewood Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-da94-7105-bef8-ae2c4f7f3708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-da94-7105-bef8-ae2c4f7f3708",
        "storage_key": "property/6767906449167252/019d0229-da94-7105-bef8-ae2c4f7f3708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/germantown-wisconsin-575/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=575",
      "poi_directions_map_url": "https://maps.google.com/?cid=11277390936429439324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "43.2204505",
      "poi_longitude": "-88.1257086",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 262-502-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdI43cD-BIgRXCkWd05XgZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5ccfdde7-9480-4adf-bb21-19db0dafbc47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "The Contrology Center Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Pilates studio offering individual and group sessions in a boutique setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-dd73-743c-93ae-d79935484ade.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-dd73-743c-93ae-d79935484ade",
        "storage_key": "property/6767906449167252/019d0229-dd73-743c-93ae-d79935484ade.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://contrologycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2324479398539163972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-contrology-center-pilates-studio",
      "poi_latitude": "43.2214548",
      "poi_longitude": "-88.1164419",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 414-840-9018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfQ36msP-BIgRRPmjhbI1QiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c6a4966c-aa5c-48b8-a775-d85927dcc9fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Chiropractic Company of Germantown",
      "poi_type": "Health and Wellness",
      "poi_address": "W164N11269 Squire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-de72-73d7-84f3-3d6a772acad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-de72-73d7-84f3-3d6a772acad3",
        "storage_key": "property/6767906449167252/019d0229-de72-73d7-84f3-3d6a772acad3.webp",
        "width": 820,
        "height": 312
      },
      "poi_business_url": "https://www.chiropracticco.com/chiropractor/germantown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3057721476257409899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chiropractic-company-of-germantown",
      "poi_latitude": "43.2222515",
      "poi_longitude": "-88.1136849",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-250-1948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYROycb-BIgRa-tnbns1byo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_c824f3c8-ad09-4e06-9ad0-5089c510248b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Blackstone Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N112W17300 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Golf course with water hazards and a clubhouse offering pizza and a bar.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.blackstonecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1463036611227171210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackstone-creek-golf-club",
      "poi_latitude": "43.2218093",
      "poi_longitude": "-88.12407739999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 262-255-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9ed-74f0-85dd-048c07812c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9ed-74f0-85dd-048c07812c34",
        "storage_key": "property/6767906449167252/019d0229-f9ed-74f0-85dd-048c07812c34.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11aeud7-BIgRijmW4QvATRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_facd7a22-d104-4391-8580-01b46d955337",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Little League Park - Fields 1 - 3",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Division Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://germantownlittleleague.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12114362715815031987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-league-park---fields-1---3",
      "poi_latitude": "43.2361176",
      "poi_longitude": "-88.1220022",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRuRatP-BIgRszRklLTcHqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_c9ceeb80-1c4c-45be-9f9f-11712eb3a14a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Schoen Laufen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N108 W18500 Lilac Ln, Germantown, WI 53022, USA",
      "poi_short_description": "Picnic tables, gravel trails, and a river are featured at this kid-friendly park.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.germantownwi.gov/facilities/facility/details/Schoen-Laufen-Park-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=15326545772868690110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schoen-laufen-park",
      "poi_latitude": "43.2158924",
      "poi_longitude": "-88.138289",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYNrKRj_BIgRvmCaSS3UstQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d2833be5-1485-4083-8be5-cede64076c01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Haupt Strasse Pickleball Courts",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://germantownwi.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17895464716465748298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "haupt-strasse-pickleball-courts",
      "poi_latitude": "43.2283425",
      "poi_longitude": "-88.1202838",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF3PWtnT_BIgRSjl6a1h2Wfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_af1196fe-3892-44b3-8d07-45dc39910c97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Firemen's Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Ave, Germantown, WI 53022, USA",
      "poi_short_description": "Playground with ample space for kid-friendly outdoor sports, plus a picnic shelter and baseball field.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.germantownwi.gov/facilities/facility/details/Firemens-Park-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=6710705219123203806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firemens-park",
      "poi_latitude": "43.2335521",
      "poi_longitude": "-88.1090014",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqmrX-BIgR3s4yitc2IV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_93a28c12-2918-4cdd-af3b-629d39c16b89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Friedenfeld Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W140N11492 Country Aire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "City park with a playground, baseball fields, soccer field, and walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-de9d-75d2-a29e-b2cd6e8eaf4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-de9d-75d2-a29e-b2cd6e8eaf4e",
        "storage_key": "property/6767906449167252/019d0229-de9d-75d2-a29e-b2cd6e8eaf4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.village.germantown.wi.us/Facilities/Facility/Details/Friedenfeld-Park-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=1418972483874221531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friedenfeld-park",
      "poi_latitude": "43.2265017",
      "poi_longitude": "-88.08005229999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-250-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2Byvhr8BIgR221gv_QzsRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_17143101-ad02-422c-a8b8-3a30c532bafe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Kinderberg Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N106W14937 Buckthorn Dr, Germantown, WI 53022, USA",
      "poi_short_description": "Well-maintained park featuring a splash pad, playgrounds and tennis courts, plus baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.village.germantown.wi.us/Facilities/Facility/Details/Kinderberg-Park-6",
      "poi_directions_map_url": "https://maps.google.com/?cid=8589952644161592136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kinderberg-park",
      "poi_latitude": "43.2100738",
      "poi_longitude": "-88.09579219999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-250-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJe7DsZv-BIgRSNutGGukNXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d6b40531-0839-46ba-84c6-67f08b8baf2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Alt Bauer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Germantown, WI 53022, USA",
      "poi_short_description": "Wooded & open-air park featuring basketball & tennis courts alongside baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e038-7220-9fd5-0a2de09cd1cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e038-7220-9fd5-0a2de09cd1cb",
        "storage_key": "property/6767906449167252/019d0229-e038-7220-9fd5-0a2de09cd1cb.webp",
        "width": 1024,
        "height": 535
      },
      "poi_business_url": "https://www.germantownwi.gov/facilities/facility/details/Alt-Bauer-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=9172062733149253058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alt-bauer-park",
      "poi_latitude": "43.2119055",
      "poi_longitude": "-88.1163251",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-250-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6WTwRe_-BIgRwq31ynW2SX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01d22204-4340-4ac9-b503-d2b1e546d72c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Homestead Hollow County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N120W19809 Freistadt Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Dog-friendly park with a playground and scenic walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e242-712d-86d3-9ced9a83320c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e242-712d-86d3-9ced9a83320c",
        "storage_key": "property/6767906449167252/019d0229-e242-712d-86d3-9ced9a83320c.webp",
        "width": 1280,
        "height": 1210
      },
      "poi_business_url": "http://washingtoncountywi.hosted.civiclive.com/cms/One.aspx?portalId=16228038&pageId=17295175",
      "poi_directions_map_url": "https://maps.google.com/?cid=14088908503304631619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homestead-hollow-county-park",
      "poi_latitude": "43.231943",
      "poi_longitude": "-88.156022",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 262-335-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUojfk7_BIgRQ_VzNKPbhcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b6f2dc1d-edc4-49e5-b683-8ea8bea94c03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Dheinsville Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N128W18780 Holy Hill Rd, Germantown, WI 53022, USA",
      "poi_short_description": "Seasonal historical site featuring beer and food, alongside a museum and archery range.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-cbfe-725c-8de1-30a95361e7f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-cbfe-725c-8de1-30a95361e7f1",
        "storage_key": "property/6767906449167252/019d0229-cbfe-725c-8de1-30a95361e7f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://germantownhistoricalsociety.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3805245614646086279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dheinsville-historic-park",
      "poi_latitude": "43.2513108",
      "poi_longitude": "-88.1416436",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 262-255-1812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f9f1-72ba-a793-f23b78fee8a3",
        "storage_key": "property/6767906449167252/019d0229-f9f1-72ba-a793-f23b78fee8a3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1fGZMT4BIgRh8oXuLnyzjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3217c2cc-5ef7-4c36-a3ff-562033a8eb36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "WisDOT Park & Ride 66-10",
      "poi_type": "Transportation & Transit",
      "poi_address": "W195N10653 Lannon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wisconsindot.gov/Pages/travel/road/parknride/washi6610.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7461446244275991229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wisdot-park--ride-66-10",
      "poi_latitude": "43.2127444",
      "poi_longitude": "-88.1508284",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-548-5902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ff03-7029-991d-81d363389933.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-ff03-7029-991d-81d363389933",
        "storage_key": "property/6767906449167252/019d0229-ff03-7029-991d-81d363389933.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1IBs23_BIgRvTK-pNNhjGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_4da13e9e-d502-48bf-8887-48152a2242de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Life Church - Germantown Campus",
      "poi_type": "Transportation & Transit",
      "poi_address": "W164N11325 Squire Dr, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.lifechurchwi.com/germantown",
      "poi_directions_map_url": "https://maps.google.com/?cid=10842769780279611942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-church---germantown-campus",
      "poi_latitude": "43.2235071",
      "poi_longitude": "-88.1143846",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 262-251-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ff03-7029-991d-85f20722ce43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-ff03-7029-991d-85f20722ce43",
        "storage_key": "property/6767906449167252/019d0229-ff03-7029-991d-85f20722ce43.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ03fGMT-BIgRJhLo7qpBeZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_0fcf2c95-c200-4b3a-b22e-97a711d2df49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Washington County Fair Park & Conference Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3000 County Hwy PV, West Bend, WI 53095, USA",
      "poi_short_description": "Spacious facility cleaned and maintained for year-round use hosting seasonal shows, fairs and carnivals with rides, animals, fireworks, food and beer tents.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wcfairpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10774446469668228729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-fair-park--conference-center",
      "poi_latitude": "43.3564543",
      "poi_longitude": "-88.18659389999999",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 262-677-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-sukIjxBIgReU4JjPqFhpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_407c954e-bb91-46e1-9200-434a3f84b826",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "WisDOT Park & Ride 67-85",
      "poi_type": "Transportation & Transit",
      "poi_address": "W156N9277 Tipp St, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wisconsindot.gov/Pages/travel/road/parknride/wauk6785.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10659068730937751431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wisdot-park--ride-67-85",
      "poi_latitude": "43.18523099999999",
      "poi_longitude": "-88.1030845",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 262-548-5902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ff03-7029-991d-81d363389933.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-ff03-7029-991d-81d363389933",
        "storage_key": "property/6767906449167252/019d0229-ff03-7029-991d-81d363389933.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8XWq5m7-BIgRh7cEYIme7JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_a9245022-c9e0-455a-8a24-ca20a24892e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Milwaukee",
      "poi_type": "Transportation & Transit",
      "poi_address": "433 W St. Paul Avenue, Milwaukee, WI 53203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.amtrak.com/stations/mke",
      "poi_directions_map_url": "https://maps.google.com/?cid=14833731164217960894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milwaukee",
      "poi_latitude": "43.0343338",
      "poi_longitude": "-87.9173709",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 50 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqgYZBYgRvmnawOb_280",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_b1581acd-bbe2-46c3-9c4a-d06bb5c4627c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Milwaukee Mitchell International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5300 S Howell Ave, Milwaukee, WI 53207, USA",
      "poi_short_description": "This Milwaukee airport with Amtrak rail service features a flight museum & children's play areas.",
      "poi_long_description": "This Milwaukee airport with Amtrak rail service features a flight museum & children's play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e41d-70e1-b694-0d17c516d6c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e41d-70e1-b694-0d17c516d6c2",
        "storage_key": "property/6767906449167252/019d0229-e41d-70e1-b694-0d17c516d6c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mitchellairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13989694915943826228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milwaukee-mitchell-international-airport",
      "poi_latitude": "42.9438861",
      "poi_longitude": "-87.90076549999999",
      "poi_miles_from_property": "25",
      "poi_walking_minutes": "9 hours 20 mins",
      "poi_biking_minutes": "2 hours 54 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 414-747-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-00bf-754d-81b6-198b1f073a6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-00bf-754d-81b6-198b1f073a6f",
        "storage_key": "property/6767906449167252/019d022a-00bf-754d-81b6-198b1f073a6f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxSVqPMWBYgRNIPrzGdhJcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_77d2f218-9965-4bd0-beb4-f657eb22f9df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Washington County Highway Department",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Lang St, West Bend, WI 53090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.washcowisco.gov/departments/highway_department",
      "poi_directions_map_url": "https://maps.google.com/?cid=619771586135754767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-highway-department",
      "poi_latitude": "43.4305427",
      "poi_longitude": "-88.16696879999999",
      "poi_miles_from_property": "17",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 262-335-4435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XzzEoD1BIgRD4iAUfnemQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_01a0e8a7-ceb7-4d2f-8c27-55794a07538c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Richfield Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Richfield, WI 53076, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8086114444606072435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richfield-park--ride",
      "poi_latitude": "43.2791737",
      "poi_longitude": "-88.1972337",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9hIfrJXBIgRc2bmyz6mN3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_ef00088b-23ef-4e9a-9f82-1ed7067a67d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "West Bend West High School",
      "poi_type": "Transportation & Transit",
      "poi_address": "1305 E Decorah Rd, West Bend, WI 53095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e41d-70e1-b694-0a1aee68b3b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e41d-70e1-b694-0a1aee68b3b1",
        "storage_key": "property/6767906449167252/019d0229-e41d-70e1-b694-0a1aee68b3b1.webp",
        "width": 1280,
        "height": 599
      },
      "poi_business_url": "https://www.west-bend.k12.wi.us/whs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15005045879951276719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-bend-west-high-school",
      "poi_latitude": "43.41118549999999",
      "poi_longitude": "-88.1644785",
      "poi_miles_from_property": "15.6",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 262-335-5570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_I5w4z1BIgRrzrvSLqhPNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_96f7be9c-aa89-4f00-9a58-37ce16da669f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Kohl's Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N56 W17000, Ridgewood Dr, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "Point of interest that is likely a corporate campus with topics most mentioned in reviews including credit cards and cash.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e448-74bc-aa83-ad1b11602ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e448-74bc-aa83-ad1b11602ed9",
        "storage_key": "property/6767906449167252/019d0229-e448-74bc-aa83-ad1b11602ed9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.kohls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8158474408677655435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls-corporate",
      "poi_latitude": "43.121994",
      "poi_longitude": "-88.12321209999999",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 262-703-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f573-7192-a99a-70efce6bd2ac",
        "storage_key": "property/6767906449167252/019d0229-f573-7192-a99a-70efce6bd2ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTZql7KkBBYgRi8NYzj-5OHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cdf89f72-c5d6-452c-8d74-c833aeabde6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Enerpac Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N 86, W12500 Westbrook Crossing, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e759-73d0-ad93-998cd5d908b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e759-73d0-ad93-998cd5d908b1",
        "storage_key": "property/6767906449167252/019d0229-e759-73d0-ad93-998cd5d908b1.webp",
        "width": 1280,
        "height": 1180
      },
      "poi_business_url": "http://www.enerpactoolgroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13536450702020926379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enerpac-corporation",
      "poi_latitude": "43.1733188",
      "poi_longitude": "-88.0649924",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 262-293-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVQJMWZT9BIgRq1uLvTEi27s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_006d7244-9320-45ba-941a-aee093fa7e8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Bradley Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "W142N9101 Fountain Blvd, Menomonee Falls, WI 53051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bradleycorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14488277964953138936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bradley-corporation",
      "poi_latitude": "43.183023",
      "poi_longitude": "-88.08760079999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 262-251-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd37hK9n9BIgR-LYmBAy0EMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_680b4e02-3c38-48ff-9dd1-715f05bbb316",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Aurora Health Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N112W17975 Mequon Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://care.aurorahealthcare.org/locations/aurora-health-center-n112w17975-mequon-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=14987193283101255322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-health-center",
      "poi_latitude": "43.2190284",
      "poi_longitude": "-88.13161459999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 262-532-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQ6-ACH_BIgRmuZeq-I0_c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_053d18c0-de7b-4828-a38d-0e4f1e56830b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Enercon Industries Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N120 W19349, Freistadt Rd, Germantown, WI 53022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-e98a-7629-b589-c8e28d399611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-e98a-7629-b589-c8e28d399611",
        "storage_key": "property/6767906449167252/019d0229-e98a-7629-b589-c8e28d399611.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.enerconind.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12727816438177893092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enercon-industries-corporation",
      "poi_latitude": "43.2347411",
      "poi_longitude": "-88.1494955",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 262-255-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4sD80r_BIgR5Ir4m51JorA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_56094b10-8232-40a6-8491-eb1690f0a7ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Washington County Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "432 E Washington St, West Bend, WI 53095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15679065356333304152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-government-center",
      "poi_latitude": "43.4280166",
      "poi_longitude": "-88.1723196",
      "poi_miles_from_property": "17",
      "poi_walking_minutes": "6 hours 13 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 262-335-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-0259-74eb-8e24-f53c9747620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-0259-74eb-8e24-f53c9747620c",
        "storage_key": "property/6767906449167252/019d022a-0259-74eb-8e24-f53c9747620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuzU_2H5fBIgRWElhzt46l9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_257324d3-3605-4106-922b-9819d56e5e01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Washington County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "484 Rolfs Ave, West Bend, WI 53090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ea0c-747e-8158-dc8cfe8ac323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-ea0c-747e-8158-dc8cfe8ac323",
        "storage_key": "property/6767906449167252/019d0229-ea0c-747e-8158-dc8cfe8ac323.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9673178545139524435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-courthouse",
      "poi_latitude": "43.4274973",
      "poi_longitude": "-88.1721371",
      "poi_miles_from_property": "17",
      "poi_walking_minutes": "6 hours 13 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 262-335-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-0259-74eb-8e24-f53c9747620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-0259-74eb-8e24-f53c9747620c",
        "storage_key": "property/6767906449167252/019d022a-0259-74eb-8e24-f53c9747620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWs_Ov_yBIgRU6P416IIPoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_c4bc6d84-28cf-4226-a98d-6d16eb8c988c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Milwaukee Tool (Brookfield)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13135 W Lisbon Rd, Brookfield, WI 53005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-eabb-7753-be76-6d64342eabe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-eabb-7753-be76-6d64342eabe0",
        "storage_key": "property/6767906449167252/019d0229-eabb-7753-be76-6d64342eabe0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milwaukeetool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5460291265450910473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milwaukee-tool-brookfield",
      "poi_latitude": "43.0933386",
      "poi_longitude": "-88.0753584",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-729-3878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f1e0-738c-842a-78e277c6afb8",
        "storage_key": "property/6767906449167252/019d0229-f1e0-738c-842a-78e277c6afb8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdkTR-wDBYgRCaNe3_nZxks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_9d7b4d00-323d-4c27-8075-a390d4fcc86f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "custom",
      "poi_name": "Carroll University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 N East Ave, Waukesha, WI 53186, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-ec9b-772e-9b27-ddc33a925afa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-ec9b-772e-9b27-ddc33a925afa",
        "storage_key": "property/6767906449167252/019d0229-ec9b-772e-9b27-ddc33a925afa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.carrollu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17066497194584026694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carroll-university",
      "poi_latitude": "43.004312",
      "poi_longitude": "-88.22848150000002",
      "poi_miles_from_property": "18.7",
      "poi_walking_minutes": "6 hours 52 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 262-524-7373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-f8a3-729c-a62a-25b341524fbb",
        "storage_key": "property/6767906449167252/019d0229-f8a3-729c-a62a-25b341524fbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv23tox-mBYgRRq5hu8Zg2Ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_556b134d0d7a076612a84456",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_1ed81c47cb912185b090f0b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_acc64d2c612dca631040d9bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e4aa995fa8a2eb756d0ebaf5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e459279a83b4c14d89e624bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_19f8841d724ad4235956d70d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "rating": "5",
      "name": "Darlene Washington",
      "text": "I absolutely love my new home. Megan made me love it before I ever saw the unit. After I saw it I was captivated. What really won me over was how friendly and helpful Megan and Andy have been. They respond immediately to my requests, calls or questions. Every step of the process was made easy and enjoyable. Including speaking with another location's manager that led me to Rivers Cove. I am absolutely never moving again!",
      "date": "2020-09-15",
      "title": "false"
    },
    {
      "id": "ec_b5f4dc9e27744f553bd333a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "rating": "5",
      "name": "Nat Patrice",
      "text": "I am relocating back to the area and came across Rivers Cove Apartments after applying to several others. I wasn't impressed until I saw Rivers Cove. I corresponded with Kate multiple times via email and called her at least ten times with various questions. She was incredibly kind, sweet, and professional, with unmatched patience. I toured two apartment homes and loved them both. Kate even helped me decide where to place my furniture. Speaking with residents on the resident portal also helped me make an informed decision. The property is very pleasant and well-maintained. I look forward to moving into my new home. If you're considering a new place, I highly recommend reaching out to Rivers Cove. I haven't moved in yet, but I'm very excited to do so. Thank you so much Kate",
      "date": "2024-06-08",
      "title": "false"
    },
    {
      "id": "ec_fe8f37900cde7cb7e23872eb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "rating": "5",
      "name": "Tim Honhorst",
      "text": "Long term resident and have really enjoyed my time here. Great staff, great area. Would recommend to all!! Adding to my review: May 2025 - I’ve had an outstanding experience living at Rivers Cove Apartments! From the beautifully maintained grounds to the quiet, friendly atmosphere, everything about this community makes it feel like home.\n\nOne of the standout parts of living here is the amazing team that keeps everything running smoothly. The Community Director, Kate, is incredible—warm, responsive, and always going the extra mile to support residents. You can tell she truly cares about creating a positive living experience for everyone.\n\nAnd a special shoutout to Garret, the maintenance technician! He’s professional, knowledgeable, and always shows up with a great attitude. Whether it's a minor fix or a bigger job, Garret handles everything with care and skill. It’s such a comfort knowing that any issue will be taken care of promptly and done right the first time. Also, maintenance requests are handled quickly and efficiently.\n\nIf you're looking for a well-run, welcoming place to live with a team that truly cares, I highly recommend Rivers Cove Apartments!",
      "date": "2025-05-05",
      "title": "false"
    },
    {
      "id": "ec_bb132ca39e24b2697d07a7ae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "rating": "5",
      "name": "Sarah Greco",
      "text": "Maintenance team here at Rivers Cove is top notch! My garbage disposal failed earlier this week- I indicated I'd be home today and Garrett was here promptly to replace it - quick & clean! Professional & Courteous as always! Thank You!",
      "date": "2025-05-16",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_5b3492f21516a7577c48afac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "2497856",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 350,
      "fee": 0,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_f6f00e39c3b2e67c704db095",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "yardi",
      "external_id": "2497855",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 75,
      "deposit": 350,
      "fee": 0,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-e23b-77dd-b11a-e84e6bcf19c5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "River's Cove Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-germantown-wi",
      "search_query": "apartments with in-unit washer dryer in Germantown WI",
      "category": "Amenity",
      "h1_title": "Germantown WI Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Discover the convenience of apartments with in-unit washer dryer in Germantown, WI. River's Cove offers this sought-after amenity for your comfort.",
      "page_copy": "River's Cove in Washington County, Germantown, WI, is an ideal location if you are on the lookout for apartments with in-unit washer dryer. These spacious homes provide the perfect blend of modern amenities and serene living, ensuring a comfortable lifestyle whether you're tackling laundry day or unwinding by the cozy fireplace.\n\nIn addition to the in-home washer and dryer, River's Cove offers a range of features including walk-in closets, a kitchen to inspire your inner chef, and a Serenity Pond for peaceful strolls. This combination of practical and pretty amenities makes it easy to see why River's Cove is the perfect place to call home. Explore the advantages of living in an apartment equipped with everything you need, right within Germantown, WI.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Germantown WI Apartments with In-Unit Laundry",
      "seo_description": "Experience convenience with Germantown WI apartments featuring in-unit washer dryer at River's Cove. Enjoy modern amenities and serene living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-washington-county-wi",
      "search_query": "pet friendly apartments near Washington County WI",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments Near Washington County WI",
      "h2_subtitle": "Explore pet friendly apartments near Washington County, WI. River's Cove offers a welcoming environment for you and your furry companions.",
      "page_copy": "For those searching for pet-friendly apartments near Washington County, WI, River's Cove in Germantown is a perfect choice. Offering a welcoming atmosphere for both you and your four-legged friends, these apartments blend comfort with convenience, featuring modern amenities such as in-home washer and dryer and walk-in closets.\n\nLocated in a serene environment with a beautiful Serenity Pond, River's Cove is designed with both people and pets in mind. Enjoy the ample space for walks and play while benefitting from the convenience of pet-friendly living. Embrace a lifestyle where you and your pets can thrive in a community that understands the joy and companionship pets bring.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments Near Washington County WI",
      "seo_description": "Find pet friendly apartments near Washington County WI at River's Cove, Germantown. Perfect for you and your furry friends with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "stainless-steel-appliances-apartments-germantown-53022",
      "search_query": "apartments with stainless steel appliances in Germantown 53022",
      "category": "Amenity",
      "h1_title": "Germantown 53022 Apartments with Stainless Steel",
      "h2_subtitle": "Discover apartments with stainless steel appliances in Germantown 53022. Modern kitchens await at River's Cove.",
      "page_copy": "Experience modern living at River's Cove in Germantown, 53022, where you can find apartments with sleek stainless steel appliances. These residences provide a contemporary kitchen aesthetic, allowing you to enjoy both style and functionality in your culinary ventures.\n\nBesides the well-equipped kitchens, River's Cove offers plenty of appealing amenities, including walk-in closets, an in-home washer and dryer, and a charming Serenity Pond ideal for relaxation. Positioned in Washington County, this community combines convenience with a peaceful environment, making it the perfect choice for those seeking modern comforts in Germantown.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Germantown 53022 Apartments with Stainless Steel",
      "seo_description": "Explore Germantown 53022 apartments with stainless steel appliances at River's Cove. Enjoy modern kitchens and amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "golf-course-view-apartments-washington-county-wi",
      "search_query": "golf course view apartments in Washington County WI",
      "category": "Amenity",
      "h1_title": "Golf Course View Apartments in Washington County WI",
      "h2_subtitle": "Explore golf course view apartments in Washington County, WI. River's Cove provides serene living in Germantown with nearby golf options.",
      "page_copy": "Imagine waking up every morning to picturesque views of tranquil greens and lush fairways. At River's Cove in Germantown, situated in the heart of Washington County, WI, you can have that lifestyle in our golf course view apartments. These sophisticated homes provide the perfect backdrop for those who appreciate the beauty of the outdoors right from their living room.\n\nRiver's Cove combines the luxury of a golf course view with plush amenities like walk-in closets, in-home washer and dryer, and a cozy fireplace. Just minutes from local golf courses, this community ensures you have access to the best recreation while enjoying a home that prioritizes your comfort and style, making it an unbeatable choice in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Golf Course View Apartments in Washington County WI",
      "seo_description": "Find golf course view apartments in Washington County WI at River's Cove in Germantown. Enjoy scenic views and luxury living close to golf options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "air-conditioning-apartments-germantown-wi",
      "search_query": "apartments with air conditioning in Germantown WI",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Germantown WI",
      "h2_subtitle": "Find apartments with air conditioning in Germantown, WI. River's Cove offers this and more for comfortable living.",
      "page_copy": "Stay cool and comfortable at River's Cove, where you'll find apartments equipped with air conditioning in Germantown, WI. Central air conditioning ensures you can enjoy a pleasant home environment year-round, no matter the season.\n\nBeyond air-conditioned comfort, River's Cove enhances your lifestyle with numerous amenities like a stunning Serenity Pond and thoughtfully designed interiors including fireplaces and walk-in closets. Conveniently located in Washington County, our community combines the best of modern living with the peace and quiet of a suburban setting, tailored for those who seek comfort and convenience in Germantown.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Germantown WI",
      "seo_description": "Discover air-conditioned apartments in Germantown WI at River's Cove. Enjoy comfort and convenience in a well-equipped community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-germantown-wi",
      "search_query": "two bedroom apartments in Germantown WI",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Germantown WI",
      "h2_subtitle": "Discover spacious two bedroom apartments in Germantown, WI. River's Cove offers modern amenities with plenty of living space.",
      "page_copy": "Welcome to River's Cove, where our two bedroom apartments in Germantown, WI provide ample space and comfort. These thoughtfully designed homes offer room to grow, making them perfect for roommates, families, or anyone seeking extra room.\n\nOur two bedroom apartments are not just about space—they come with a suite of amenities including a kitchen with modern appliances, in-home washer and dryer, and walk-in closets. Plus, you can unwind by the Serenity Pond or cozy up by the fireplace. Located in the charming Washington County, River's Cove blends quiet suburban living with convenient access to Germantown's local attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Germantown WI",
      "seo_description": "Explore spacious two bedroom apartments in Germantown WI at River's Cove. Enjoy modern amenities and a tranquil living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167252",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-washington-county-wi",
      "search_query": "three bedroom floorplans Washington County WI",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans in Washington County WI",
      "h2_subtitle": "Explore expansive three bedroom floorplans in Washington County, WI. River's Cove offers space and style for all your living needs.",
      "page_copy": "River's Cove presents exceptional three bedroom floorplans in Washington County, WI, perfect for families or those needing extra space. Each home is designed with care, offering a combination of comfort and style that accommodates a variety of lifestyle needs.\n\nExperience the blend of luxury and practicality with features like in-home washer and dryer, central air, and cozy fireplaces. Our community, nestled in Germantown, ensures that you can enjoy a serene environment while taking advantage of local amenities. With a floorplan to fit any family dynamic, River's Cove is the ideal choice for spacious living in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans in Washington County WI",
      "seo_description": "Find spacious three bedroom floorplans in Washington County WI at River's Cove. Enjoy modern amenities and stylish living spaces in Germantown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309827744"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2622934725"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MM5VT4GG"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "92f10630-479f-489d-b42e-265074c046fe"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/9b4b8c87-6d0b-46f4-9a17-f4d1516f0894/app.js?property=9b4b8c87-6d0b-46f4-9a17-f4d1516f0894&propertyName=River%27s+Cove&channelUuid=c248eb3d-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47737656697"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1JRnVyZVZJdjhiWEd0UkYzc1AxQVE9PSIsInZhbHVlIjoibnJ6QjNiMlk2RVlRclJOanladFkxUT09IiwibWFjIjoiNGRmZjU3YmQ0MTgyMjRiMTQ1YzU2ZmY0NjZjZmIwZjQ2MGRhMDliNDIwYTIxYTFiNjIwMDUyOTQ5ZjgyY2FhZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309827744",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2622934725",
  "custom_google_gtm_id": "GTM-MM5VT4GG",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "92f10630-479f-489d-b42e-265074c046fe",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/9b4b8c87-6d0b-46f4-9a17-f4d1516f0894/app.js?property=9b4b8c87-6d0b-46f4-9a17-f4d1516f0894&propertyName=River%27s+Cove&channelUuid=c248eb3d-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47737656697",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1JRnVyZVZJdjhiWEd0UkYzc1AxQVE9PSIsInZhbHVlIjoibnJ6QjNiMlk2RVlRclJOanladFkxUT09IiwibWFjIjoiNGRmZjU3YmQ0MTgyMjRiMTQ1YzU2ZmY0NjZjZmIwZjQ2MGRhMDliNDIwYTIxYTFiNjIwMDUyOTQ5ZjgyY2FhZSJ9",
  "custom_audioeye_site_id": "1296fd3d-1773-4ac2-aa66-878305a3f311",
  "custom_audioeye_site_hash": "9f34a1aea7ade6431dbcd80dfb20e5d5"
};

export const generatedAt = '2026-11-04T23:48:46.907Z';
